"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCommonConfiguration = exports.handleChartLoad = exports.MINIMUM_HC_SAFE_BRIGHTNESS = exports.HOVER_BRIGHTNESS = exports.MAX_POINT_WIDTH = exports.DEFAULT_DATA_POINTS_LIMIT = exports.DEFAULT_CATEGORIES_LIMIT = exports.DEFAULT_SERIES_LIMIT = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var invoke_1 = tslib_1.__importDefault(require("lodash/invoke"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var set_1 = tslib_1.__importDefault(require("lodash/set"));
var variables_1 = require("./styles/variables");
var common_1 = require("../_util/common");
var drilldownEventing_1 = require("./drilldownEventing");
var setupDrilldownToParentAttribute_1 = require("./setupDrilldownToParentAttribute");
var lib_1 = tslib_1.__importDefault(require("../../lib"));
var chartCapabilities_1 = require("../_chartOptions/chartCapabilities");
var isTouchDevice = "ontouchstart" in window || navigator.msMaxTouchPoints;
var HIGHCHART_PLOT_LIMITED_RANGE = 1e5;
exports.DEFAULT_SERIES_LIMIT = 1000;
exports.DEFAULT_CATEGORIES_LIMIT = 365;
exports.DEFAULT_DATA_POINTS_LIMIT = 2000;
exports.MAX_POINT_WIDTH = 100;
exports.HOVER_BRIGHTNESS = 0.1;
exports.MINIMUM_HC_SAFE_BRIGHTNESS = Number.MIN_VALUE;
function handleTooltipOffScreen(renderTo) {
    // allow tooltip over the container wrapper
    lib_1.default.css(renderTo, { overflow: "visible" });
}
function fixNumericalAxisOutOfMinMaxRange(axis) {
    var range = axis.max - axis.min;
    if (range < 0) {
        // all data points is outside
        axis.translationSlope = axis.transA = HIGHCHART_PLOT_LIMITED_RANGE;
    }
}
var previousChart = null;
function getThemedConfiguration(theme) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    var backgroundColor = (_e = (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.chart) === null || _a === void 0 ? void 0 : _a.backgroundColor) !== null && _b !== void 0 ? _b : (_d = (_c = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _c === void 0 ? void 0 : _c.complementary) === null || _d === void 0 ? void 0 : _d.c0) !== null && _e !== void 0 ? _e : variables_1.styleVariables.gdColorBackground;
    var axisLineColor = (_k = (_g = (_f = theme === null || theme === void 0 ? void 0 : theme.chart) === null || _f === void 0 ? void 0 : _f.axisColor) !== null && _g !== void 0 ? _g : (_j = (_h = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _h === void 0 ? void 0 : _h.complementary) === null || _j === void 0 ? void 0 : _j.c4) !== null && _k !== void 0 ? _k : variables_1.styleVariables.gdColorAxisLine;
    return {
        credits: {
            enabled: false,
        },
        title: {
            // setting title to empty string prevents it from being shown
            text: "",
        },
        series: [],
        legend: {
            enabled: false,
        },
        drilldown: {
            activeDataLabelStyle: {
                color: (_o = (_m = (_l = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _l === void 0 ? void 0 : _l.complementary) === null || _m === void 0 ? void 0 : _m.c9) !== null && _o !== void 0 ? _o : "#000",
                textDecoration: "none",
            },
            activeAxisLabelStyle: {
                color: (_r = (_q = (_p = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _p === void 0 ? void 0 : _p.complementary) === null || _q === void 0 ? void 0 : _q.c8) !== null && _r !== void 0 ? _r : variables_1.styleVariables.gdColorText,
                textDecoration: "none",
            },
            drillUpButton: {
                theme: {
                    style: {
                        // https://forum.highcharts.com/highcharts-usage/empty-checkbox-
                        // after-drilldown-with-x-axis-label-t33414/
                        display: "none",
                    },
                },
            },
        },
        plotOptions: {
            series: {
                animation: false,
                enableMouseTracking: true,
                turboThreshold: exports.DEFAULT_CATEGORIES_LIMIT,
                borderColor: backgroundColor,
                dataLabels: {
                    style: {
                        textOutline: "none",
                    },
                },
                events: {
                    legendItemClick: function () {
                        if (this.visible) {
                            this.points.forEach(function (point) { return point.dataLabel && point.dataLabel.hide(); });
                        }
                    },
                },
                point: {
                    events: {
                        click: function () {
                            var _a, _b;
                            if (isTouchDevice) {
                                // Close opened tooltip on previous clicked chart
                                // (click between multiple charts on dashboards)
                                var currentChart = this.series.chart;
                                var currentId = (_a = currentChart === null || currentChart === void 0 ? void 0 : currentChart.container) === null || _a === void 0 ? void 0 : _a.id;
                                var prevId = (_b = previousChart === null || previousChart === void 0 ? void 0 : previousChart.container) === null || _b === void 0 ? void 0 : _b.id;
                                var previousChartDisconnected = isEmpty_1.default(previousChart);
                                if (previousChart && !previousChartDisconnected && prevId !== currentId) {
                                    // Remove line chart point bubble
                                    invoke_1.default(previousChart, "hoverSeries.onMouseOut");
                                    previousChart.tooltip.hide();
                                }
                                if (!previousChart || prevId !== currentId) {
                                    previousChart = currentChart;
                                }
                            }
                        },
                    },
                },
            },
        },
        chart: {
            animation: false,
            backgroundColor: backgroundColor,
            style: {
                fontFamily: 'gdcustomfont, Avenir, "Helvetica Neue", Arial, sans-serif',
            },
            events: {
                afterGetContainer: function () {
                    handleTooltipOffScreen(this.renderTo);
                },
            },
        },
        xAxis: [
            {
                lineColor: axisLineColor,
                events: {
                    afterSetAxisTranslation: function () {
                        fixNumericalAxisOutOfMinMaxRange(this);
                    },
                },
            },
        ],
        yAxis: [
            {
                lineColor: axisLineColor,
            },
        ],
    };
}
function registerDrilldownHandler(configuration, chartOptions, drillConfig) {
    set_1.default(configuration, "chart.events.drilldown", function chartDrilldownHandler(event) {
        drilldownEventing_1.chartClick(drillConfig, event, this.container, chartOptions.type);
    });
    return configuration;
}
function handleChartLoad(chartType) {
    return function () {
        if (!this.hasLoaded) {
            // setup drill on initial render
            setupDrilldownToParentAttribute_1.setupDrilldown(this, chartType);
        }
    };
}
exports.handleChartLoad = handleChartLoad;
function registerRenderHandler(configuration, chartOptions) {
    if (common_1.isOneOfTypes(chartOptions.type, chartCapabilities_1.supportedDualAxesChartTypes)) {
        set_1.default(configuration, "chart.events.render", handleChartLoad(chartOptions.type));
    }
    return configuration;
}
function getCommonConfiguration(chartOptions, drillConfig, theme) {
    var commonConfiguration = getThemedConfiguration(theme);
    var handlers = [registerDrilldownHandler, registerRenderHandler];
    return handlers.reduce(function (configuration, handler) { return handler(configuration, chartOptions, drillConfig); }, commonConfiguration);
}
exports.getCommonConfiguration = getCommonConfiguration;
//# sourceMappingURL=commonConfiguration.js.map